export class WorkOrderManageWorkFlowParametersDto {
    workFlowIdsToLink: Array<number>;
    workFlowIdsToUnLink: Array<number>;
    communityId: number;
    workOrderId: number;
}
